/** Normalize API login payloads (password + Google). */
export function isLoginSuccessResponse(res) {
    if (!res || typeof res !== 'object') return false;
    const s = res.status;
    return typeof s === 'string' && s.toLowerCase() === 'success';
}

export function getLoginToken(res) {
    if (!res || typeof res !== 'object') return '';
    const t = res.token != null ? res.token : res.access_token;
    return typeof t === 'string' && t.length > 0 ? t : '';
}

function enrichWithHttpStatus(body, httpStatus) {
    if (!body || typeof body !== 'object') {
        return { status: 'failure', httpStatus, reason: `Server error (${httpStatus})` };
    }
    return { ...body, httpStatus };
}

export async function logInWithGoogleCredential(credential) {
    try {
        const res = await fetch(window.SERVER_URL + '/a/login/google', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ credential })
        });

        const clonedRes = res.clone();
        let responseData;
        try {
            responseData = await res.json();
        } catch (jsonErr) {
            try {
                const text = await clonedRes.text();
                console.error('Failed to parse JSON response:', text);
                return {
                    status: 'failure',
                    httpStatus: res.status,
                    reason: `Server error (${res.status}): ${text.substring(0, 100) || 'Unknown error'}`
                };
            } catch (textErr) {
                return {
                    status: 'failure',
                    httpStatus: res.status,
                    reason: `Server error (${res.status}): Cannot read response.`
                };
            }
        }

        if (!res.ok) {
            return enrichWithHttpStatus(
                responseData || { status: 'failure', reason: `Server error (${res.status})` },
                res.status
            );
        }

        return enrichWithHttpStatus(responseData, res.status);
    } catch (err) {
        console.error('Network error:', err);
        if (err.name === 'TypeError' && err.message.includes('Failed to fetch')) {
            return {
                status: 'failure',
                reason: 'Cannot connect to server. Make sure the API is reachable.'
            };
        }
        return {
            status: 'failure',
            reason: `Connection error: ${err.message}`
        };
    }
}

export async function LogIn(data) {
    // Connect directly to backend API
    try {
        const res = await fetch(window.SERVER_URL + '/a/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        
        // Clone the response to read it safely
        const clonedRes = res.clone();
        
        // Try to parse as JSON first
        let responseData;
        try {
            responseData = await res.json();
        } catch (jsonErr) {
            // If JSON parsing fails, try reading as text (only once)
            try {
                const text = await clonedRes.text();
                console.error('Failed to parse JSON response:', text);
                return { 
                    status: 'failure',
                    httpStatus: res.status,
                    reason: `Server error (${res.status}): ${text.substring(0, 100) || 'Unknown error'}` 
                };
            } catch (textErr) {
                // If we can't read text either, return generic error
                return { 
                    status: 'failure',
                    httpStatus: res.status,
                    reason: `Server error (${res.status}): Cannot read response. Make sure Flask is running on port 5000.` 
                };
            }
        }
        
        // If response is not OK and we got JSON, return it
        if (!res.ok) {
            return enrichWithHttpStatus(
                responseData || { status: 'failure', reason: `Server error (${res.status})` },
                res.status
            );
        }
        
        // Success case
        return enrichWithHttpStatus(responseData, res.status);
        
    } catch (err) {
        console.error('Network error:', err);
        // Handle different types of errors
        if (err.name === 'TypeError' && err.message.includes('Failed to fetch')) {
            return { 
                status: 'failure', 
                reason: 'Cannot connect to server. Make sure Flask is running on port 5000.' 
            };
        }
        return { 
            status: 'failure', 
            reason: `Connection error: ${err.message}` 
        };
    }
}
